export default {
    id: 'ID',
    invoice_id: 'Invoice ID',
    username: 'USERNAME',
    service: 'Service',
    reg_date: 'Reg Date',
    amount: 'Amount',
    refund: 'Refund',
    status: 'Status',
    payment: 'Payment',
    edit: 'Edit',
    view_log: 'View Log',
    edit_title: 'Edit invoice',
    description_service: 'DESCRIPTION SERVICE',
    unit_price: 'UNIT PRICE',
    discount: 'Discount',
    total_discount: 'Total Discount',
    description: 'DESCRIPTION',
    phone: 'Phone number',
    full_name: 'Full name',
    bank_name: 'Bank Name',
    account_name: 'Account Name',
    account_number: 'Account Number',
    branch: 'Branch',
    branch_code: 'Branch Code',
    transfer_amount: 'Transfer Amount',
    transfer_description: 'Transfer Description',
    sub_total: 'SubTotal',
    tax_rate: 'TAX RATE',
    taxWithPercent: 'Tax ({percent}%)',
    vatWithPercent: 'VAT ({percent}%)',
    whtWithPercent: 'Withholding Tax ({percent}%)',
    taxWithoutPercent: 'Tax',
    whtWithoutPercent: 'Withholding Tax',
    total: 'Total',
    for: 'for',
    failed_service: '{failedService} service(s) failed',
    my_invoice_info: 'Invoice Information',
    promotion_code: 'Promotion code',
    invoice_list: 'Invoice List',
    my_invoice_detail: 'Invoice Detail',
    dashboard: 'Dashboard',
    detail: 'Detail',
    days: 'day(s)',
    months: 'month(s)',
    years: 'year(s)',
    register_action: 'registration',
    renew_action: 'renewal',
    reactivate_action: 'reactivation',
    transfer_action: 'transfer',
    purchase_action: 'purchase',
    upgrade_action: 'upgrade',
    backup_action: 'backup',
    server_name: 'Server name:',
    website_name: 'Website name:',
    connected_with: 'Connected with:',
    from: 'From:',
    machine_name: 'Machine name',
    payment_method: 'Payment Method',
    transaction_id: 'Transaction ID',
    purchase_id: 'Purchase ID',
    payment_fee: 'PayPal’s Fee',
    payway_fee: 'PayWay’s Fee',
    payment_amount: 'Payment Amount',
    refund_amount: 'Refund Amount',
    type: 'Type',
    qty: 'QTY',
    upgrade_fee: 'Upgrade Fee',
    edit_company_info: 'Edit company info',
    order_summary: 'Order Summary',
    excluding_vat: 'Excluding: {taxes}',
    card_number: 'Card Number',
    amount_from: 'Amount from',
    download_vat_invoice: 'Download VAT Invoice',
    aws_waiting_for_payment_description:
        'This invoice is automatically generated for the AWS Service, it has not been paid',
    waiting_for_payment: 'Waiting for payment',
    service_id: 'Service ID',
    service_id_placeholder: 'Service ID',
    swift_code: 'SWIFT code',
    aws_account: 'AWS Account',
    support_hours_des: 'Support for all clients - {supportHours} hrs total',
};
